module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "nav",
    on: {
      "click": function($event) {
        _vm.changeType($event)
      }
    }
  }, _vm._l((_vm.type), function(item) {
    return _c('span', {
      class: {
        'active': item.value === _vm.currentType
      },
      attrs: {
        "data-type": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d0ca32e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/nav/Nav.vue
// module id = 663
// module chunks = 0